import type { SVGProps } from "react";

const ThinLeftAngle: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="thin left angle icon">
      {/* <title>thin left angle icon</title> */}
      <path
        d="M7.98533 10.6351L3.77475 6.37958C3.65103 6.23706 3.59998 6.10345 3.59998 5.98988C3.59998 5.87631 3.651 5.72333 3.75377 5.62045L7.96436 1.36495C8.17482 1.15131 8.52409 1.14436 8.74393 1.34895C8.96527 1.55215 8.97246 1.89163 8.76046 2.10407L4.91627 5.98988L8.77962 9.89576C8.99162 10.1073 8.98442 10.4476 8.76309 10.6509C8.54414 10.8555 8.1946 10.8488 7.98533 10.6351Z"
        fill={props.fill || "currentColor" || "#A1A1AA"}
      />
    </svg>
  );
};

export default ThinLeftAngle;
